module.exports = __webpack_public_path__ + "img/step2a.a1dc9cc4.svg";